import { STANDARDS_DATA } from '../constants/nationalStandardsData'

export const parseTimeToSeconds = (str, isLongRun = false) => {
  if (typeof str === 'number') return str
  if (!str) return 0
  const s = String(str).trim()
  if (s.includes("'") || s.includes('"')) {
    const parts = s.replace(/["']/g, ' ').trim().split(/\s+/)
    const mins = parseFloat(parts[0]) || 0
    const secs = parseFloat(parts[1]) || 0
    return mins * 60 + secs
  }
  if (s.includes(':')) {
    const parts = s.split(':')
    const mins = parseFloat(parts[0]) || 0
    const secs = parseFloat(parts[1]) || 0
    return mins * 60 + secs
  }
  if (isLongRun && s.includes('.')) {
    const parts = s.split('.')
    const mins = parseFloat(parts[0]) || 0
    const secs = parseFloat(parts[1]) || 0
    return mins * 60 + secs
  }
  return parseFloat(s) || 0
}

export const getStandardGradeName = (cls) => {
  if (!cls) return '小学一年级'
  const gradeStr = typeof cls === 'string' ? cls : (cls.grade || '')
  const gradeCode = typeof cls === 'object' ? cls.grade_code : null

  if (gradeStr && gradeStr.includes('小学')) return gradeStr
  if (gradeStr && gradeStr.includes('初中')) return gradeStr
  if (gradeStr && gradeStr.includes('高中')) return gradeStr
  if (gradeCode) {
    const phase = gradeCode.substring(0, 1)
    const level = gradeCode.substring(1)
    const numMap = { '1': '一', '2': '二', '3': '三', '4': '四', '5': '五', '6': '六' }
    if (phase === '1') return `小学${numMap[level] || '一'}年级`
    if (phase === '2') return `初中${numMap[level] || '一'}年级`
    if (phase === '3') return `高中${numMap[level] || '一'}年级`
  }
  if (gradeStr) {
    if (gradeStr.includes('初')) return gradeStr.replace('初', '初中') + (gradeStr.endsWith('年级') ? '' : '年级')
    if (gradeStr.includes('高')) return gradeStr.replace('高', '高中') + (gradeStr.endsWith('年级') ? '' : '年级')
    return `小学${gradeStr}`
  }
  return '小学一年级'
}

export const TEST_ITEMS = [
  {
    key: 'height_weight',
    label: '身高/体重',
    isCompound: true,
    items: [
      { key: 'height', label: '身高', unit: 'cm' },
      { key: 'weight', label: '体重', unit: 'kg' }
    ],
    grades: ['1', '2', '3', '4']
  },
  { key: 'vital_capacity', label: '肺活量', unit: 'ml', grades: ['1', '2', '3', '4'] },
  { key: 'run_50m', label: '50米跑', unit: '秒', grades: ['1', '2', '3', '4'] },
  { key: 'sit_and_reach', label: '坐位体前屈', unit: 'cm', grades: ['1', '2', '3', '4'] },
  { key: 'skip_rope', label: '1分钟跳绳', unit: '次', grades: ['1'] },
  { key: 'sit_up', label: '1分钟仰卧起坐', unit: '次', grades: ['13', '14', '15', '16', '2', '3', '4'] },
  { key: 'standing_long_jump', label: '立定跳远', unit: 'cm', grades: ['2', '3', '4'] },
  { key: 'run_50m_8x', label: '50米×8往返跑', unit: '分·秒', grades: ['15', '16'] },
  { key: 'run_800m', label: '800米跑', unit: '分·秒', grades: ['2', '3', '4'] },
  { key: 'run_1000m', label: '1000米跑', unit: '分·秒', grades: ['2', '3', '4'] },
  { key: 'pull_up', label: '引体向上', unit: '次', grades: ['2', '3', '4'] },
]

export const checkStudentScorePass = (student, item, scoreVal, gradeName) => {
  const colorMap = {
    excellent: { text: '#059669', bg: '#ECFDF5', border: '#A7F3D0' },
    good: { text: '#0891B2', bg: '#ECFEFF', border: '#A5F3FC' },
    pass: { text: '#D97706', bg: '#FFFBEB', border: '#FDE68A' },
    fail: { text: '#E11D48', bg: '#FFF1F2', border: '#FECDD3' },
    exempt: { text: '#7C3AED', bg: '#F5F3FF', border: '#DDD6FE' },
    absent: { text: '#E11D48', bg: '#FFF1F2', border: '#FECDD3' },
    untested: { text: '#94A3B8', bg: '#F1F5F9', border: '#E2E8F0' },
  }

  if (!item || !student || scoreVal === undefined || scoreVal === null || scoreVal === '') {
    const theme = colorMap.untested
    return {
      tested: false,
      passed: false,
      score: null,
      scoreText: '--',
      gradeText: '待测',
      status: 'untested',
      scoreColor: theme.text,
      gradeBg: theme.bg,
      gradeBorder: theme.border,
      reason: '未录入'
    }
  }

  if (scoreVal === '缺考') {
    const theme = colorMap.absent
    return {
      tested: true,
      passed: false,
      score: 0,
      scoreText: '0分',
      gradeText: '缺考',
      status: 'absent',
      scoreColor: theme.text,
      gradeBg: theme.bg,
      gradeBorder: theme.border,
      reason: '缺考'
    }
  }

  if (scoreVal === '免考' || scoreVal === '缓考' || scoreVal === '免测') {
    const theme = colorMap.exempt
    return {
      tested: true,
      passed: true,
      score: null,
      scoreText: scoreVal,
      gradeText: scoreVal,
      status: 'exempt',
      scoreColor: theme.text,
      gradeBg: theme.bg,
      gradeBorder: theme.border,
      reason: scoreVal
    }
  }

  // 身高体重复合项 (BMI 计算)
  if (item.isCompound) {
    const h = scoreVal?.height
    const w = scoreVal?.weight
    if (!h || !w || h === '' || w === '') {
      const theme = colorMap.untested
      return {
        tested: false,
        passed: false,
        score: null,
        scoreText: '--',
        gradeText: '未全',
        status: 'untested',
        scoreColor: theme.text,
        gradeBg: theme.bg,
        gradeBorder: theme.border,
        reason: '身高或体重未录全'
      }
    }
    const hNum = parseFloat(h)
    const wNum = parseFloat(w)
    if (hNum <= 0 || wNum <= 0) {
      const theme = colorMap.untested
      return {
        tested: false,
        passed: false,
        score: null,
        scoreText: '--',
        gradeText: '无效',
        status: 'untested',
        scoreColor: theme.text,
        gradeBg: theme.bg,
        gradeBorder: theme.border,
        reason: '数值不合法'
      }
    }
    const hM = hNum / 100
    const bmi = parseFloat((wNum / (hM * hM)).toFixed(1))
    const genderKey = (student.gender === 'female' || student.gender === '女') ? '女' : '男'
    const stdKey = `${gradeName}_${genderKey}_bmi`
    const std = STANDARDS_DATA ? STANDARDS_DATA[stdKey] : null

    let score = 100
    let gradeText = '正常'
    let status = 'excellent'

    if (std && std.scoring_table) {
      const table = std.scoring_table
      let matched = false
      if (table['100']) {
        const parts = table['100'].split('~').map(Number)
        if (parts.length === 2 && bmi >= parts[0] && bmi <= parts[1]) {
          score = 100
          gradeText = '正常'
          status = 'excellent'
          matched = true
        }
      }
      if (!matched && table['80']) {
        for (let c of table['80'].split(';')) {
          if (c.startsWith('≤') && bmi <= Number(c.slice(1))) {
            score = 80
            gradeText = '低体重'
            status = 'good'
            matched = true
            break
          }
          if (c.includes('~')) {
            const parts = c.split('~').map(Number)
            if (parts.length === 2 && bmi >= parts[0] && bmi <= parts[1]) {
              score = 80
              gradeText = '超重'
              status = 'good'
              matched = true
              break
            }
          }
        }
      }
      if (!matched) {
        score = 60
        gradeText = '肥胖'
        status = 'pass'
      }
    }

    const theme = colorMap[status] || colorMap.pass
    return {
      tested: true,
      passed: score >= 60,
      score,
      scoreText: `${score}分`,
      gradeText,
      status,
      studentValue: bmi,
      scoreColor: theme.text,
      gradeBg: theme.bg,
      gradeBorder: theme.border,
      reason: gradeText
    }
  }

  const genderKey = (student.gender === 'female' || student.gender === '女') ? '女' : '男'
  let stdCode = item.key
  if (stdCode === 'run_50m_8x') stdCode = 'run_50m8x'

  const stdKey = `${gradeName}_${genderKey}_${stdCode}`
  const std = STANDARDS_DATA ? STANDARDS_DATA[stdKey] : null

  const isLongRun = ['run_800m', 'run_1000m', 'run_50m_8x', 'run_50m8x'].includes(item.key) ||
    item.label?.includes('800') || item.label?.includes('1000') || item.label?.includes('往返')
  const isRun = isLongRun || item.unit === 's' || item.unit === '秒' || item.key?.includes('run') || item.key?.includes('50m')

  let numericVal
  if (isRun) {
    numericVal = parseTimeToSeconds(scoreVal, isLongRun)
  } else {
    numericVal = parseFloat(scoreVal)
  }

  if (isNaN(numericVal) || (item.key !== 'sit_and_reach' && numericVal <= 0)) {
    const theme = colorMap.untested
    return {
      tested: false,
      passed: false,
      score: null,
      scoreText: '--',
      gradeText: '无效',
      status: 'untested',
      scoreColor: theme.text,
      gradeBg: theme.bg,
      gradeBorder: theme.border,
      reason: '成绩格式无效'
    }
  }

  let earnedScore = 0
  if (std && std.scoring_table) {
    const keys = Object.keys(std.scoring_table).map(Number).sort((a, b) => b - a)
    for (let k of keys) {
      const rawThresh = std.scoring_table[String(k)]
      const thresh = isLongRun ? parseTimeToSeconds(rawThresh, true) : parseFloat(rawThresh)
      if (isNaN(thresh)) continue
      if (isRun) {
        if (numericVal <= thresh) {
          earnedScore = k
          break
        }
      } else {
        if (numericVal >= thresh) {
          earnedScore = k
          break
        }
      }
    }
  } else {
    earnedScore = numericVal >= 60 ? 80 : 50
  }

  let gradeText = '不及格'
  let status = 'fail'
  if (earnedScore >= 90) {
    gradeText = '优秀'
    status = 'excellent'
  } else if (earnedScore >= 80) {
    gradeText = '良好'
    status = 'good'
  } else if (earnedScore >= 60) {
    gradeText = '及格'
    status = 'pass'
  }

  const theme = colorMap[status] || colorMap.fail

  return {
    tested: true,
    passed: earnedScore >= 60,
    score: earnedScore,
    scoreText: `${earnedScore}分`,
    gradeText,
    status,
    studentValue: scoreVal,
    scoreColor: theme.text,
    gradeBg: theme.bg,
    gradeBorder: theme.border,
    reason: gradeText
  }
}

